module.exports = __webpack_public_path__ + "static/email_marketing-839d21d138d870b8a3e81b35c2dfa953.png";